<template>
    <el-form-item label="">
      <el-date-picker
        v-if="isDateSelector"
        v-model="selectDate"
        type="date"
        placeholder="日期"
        :picker-options="disabledDate"
      >
      </el-date-picker>
      <el-date-picker
        v-else
        v-model="selectPeriod"
        type="daterange"
        :picker-options="pickerOptions"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        align="right"
      >
      </el-date-picker>
    </el-form-item>
</template>
<script>
import { formatDate } from '@/utils/utils';

export default {
  name: 'period-date-selector',
  props: {
    isDateSelector: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    isDateSelector() {
      this.emitStartEndData();
    },
    selectDate() {
      this.emitStartEndData();
    },
    selectPeriod() {
      this.emitStartEndData();
    },
  },
  data() {
    return {
      selectPeriod: [formatDate(new Date(), 'yyyy-MM-01'), formatDate(new Date(), 'yyyy-MM-dd')],
      selectDate: formatDate(new Date(), 'yyyy-MM-dd'),
      disabledDate: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.emitStartEndData();
  },
  methods: {
    emitStartEndData() {
      if (this.isDateSelector) {
        this.$emit('startEndDate', {
          start: this.selectDate,
          end: null,
          isDateSelector: this.isDateSelector,
        });
        return;
      }
      const [start, end] = this.selectPeriod;
      this.$emit('startEndDate', {
        start,
        end,
        isDateSelector: this.isDateSelector,
      });
    },
  },
};
</script>
